import { atom } from 'recoil';

// Ephemeral, socket-only import progress pushed by the worker (kind
// 'import-progress'). Keyed by `runKey(run)` — "<kind>-<id>", since the EHR and
// CSV ledgers number their runs independently ->
// { id, runKind, importRequestId, phase, done, total, counts, message }.
// Not persisted — purely transient UI state (the durable record is the import's
// summary + import_reference on the backend).
export const importProgressState = atom({
  key: 'importProgressState',
  default: {}
});
